import React from 'react';
import { Link } from 'react-router-dom';
import raklaposImg from '../img/raklaposszallitas.png';
import '../App.css';

const QUOTE_RAKLAP_PATH = '/ajanlat/raklapos-szallitas';

const QUOTE_ITEMS = [
  'felvételi és lerakási cím (város, irányítószám, ország)',
  'raklapok darabszáma, mérete és hozzávetőleges súlya',
  'körméreten belüli vagy attól eltérő raklapméret jelzése',
  'fel- és lerakodás körülményei (rámpa, emelő, időablak)',
  'bármilyen különleges igény (törékeny, értékes, érzékeny áru)',
];

function IconPallet() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M14 22h36v18H14V22z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M18 28h28M18 34h28"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 40v6h8v-6M40 40v6h8v-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M22 18l10-6 10 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconFleet() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M10 40h26v12H10V40zM36 40V26h12l6 14v12H36"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="20" cy="52" r="4.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="46" cy="52" r="4.5" stroke="currentColor" strokeWidth="2" />
      <path d="M14 40V34h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconHandOff() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M18 28h28v12H18V28z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10 38c4-6 10-8 18-6M54 38c-4-6-10-8-18-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 44v6M40 44v6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function RaklaposSzallitasPage() {
  return (
    <main className="svc-page">
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <nav className="svc-breadcrumb-trail" aria-label="Útvonal">
            <Link className="svc-breadcrumb-seg" to="/" state={{ scrollTo: 'szolgaltatas' }}>
              Szolgáltatások
            </Link>
            <span className="svc-breadcrumb-sep" aria-hidden="true">
              /
            </span>
            <span className="svc-breadcrumb-current" aria-current="page">
              Raklapos szállítás
            </span>
          </nav>

          <div className="svc-hero-grid">
            <div className="svc-hero-text">
              <h1>Raklapos áruk szállítása belföldön és nemzetközi viszonylatban</h1>
              <p>
                Vállalunk cégeknek és magányszemélyeknek belföldi és nemzetközi viszonylatokban raklapos
                áruk szállítását komplett és részrakományok formájában is. Ezek általában ipari
                felhasználásokhoz köthető vagy mennyiségéből kifolyólag a szállítás egyszerűsítése,
                biztonságossága miatt raklapra rögzítve szállítandó.
              </p>
              <Link className="primary-btn svc-hero-cta" to={QUOTE_RAKLAP_PATH}>
                Ajánlatot kérek
              </Link>
            </div>

            <div className="svc-hero-media">
              <img src={raklaposImg} alt="Raklapos szállítás – raklapok és áruk" />
            </div>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--cream svc-icon-rows-wrap" aria-label="Hasznos információk">
        <div className="svc-band-inner svc-icon-rows-inner">
          <p className="svc-cream-intro">
            Néhány fontos tudnivaló, hogy a raklapos szállítás a lehető leggyorsabban és biztonságosan
            megvalósuljon:
          </p>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconPallet />
            </div>
            <p className="svc-icon-row-text">
              Ilyen lehet például: <strong>darabos áru, késztermék, építőanyag</strong>, gépjármű motor
              szállítása (raklapos áruk szállítása).
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconFleet />
            </div>
            <p className="svc-icon-row-text">
              Rendelkezésre álló saját járműparkunk: <strong>20 m³ (9 EU paletta)</strong> ponyvás
              kivitelű, <strong>15 m³ (5 EU paletta)</strong> zárt furgon kivitelű járművek.
              Alvállalkozóink segítségével szinte minden méretben történő szállítást tudunk vállalni.
              Nem gond, ha a standard raklaptól eltérő a méret.
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconHandOff />
            </div>
            <p className="svc-icon-row-text">
              A raklap mozgatása, a gépkocsira történő le- és felmozgatása <strong>a feladó és a címzett
              feladata</strong>.
            </p>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--quote" aria-labelledby="raklap-quote-h">
        <div className="svc-band-inner svc-quote-layout">
          <div className="svc-quote-main">
            <h2 id="raklap-quote-h">Mi alapján készül az ajánlat?</h2>
            <p className="svc-quote-lead">A pontos ajánlathoz kérjük add meg:</p>
            <ul className="svc-bullet-list svc-bullet-list--quote">
              {QUOTE_ITEMS.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <p className="svc-tip svc-tip--in-card">
              Ha tudsz, írd le a raklapok méretét és csatolj fotót – így gyorsabban tudunk pontos
              ajánlatot adni.
            </p>
          </div>

          <aside className="svc-quote-aside" aria-labelledby="raklap-quote-info-h">
            <h2 id="raklap-quote-info-h" className="svc-quote-aside-title">
              Információk:
            </h2>
            <ul className="svc-quote-info-list">
              <li>
                Kérünk, hogy a pontos árajánlathoz <strong>minden mezőt tölts ki</strong> a valóságnak
                megfelelően!
              </li>
              <li>
                A <strong>csillaggal jelölt mezők</strong> kitöltése kötelező.
              </li>
              <li>
                Áraink <strong>nettó árak</strong>. Az Áfát nem tartalmazzák!
              </li>
              <li>
                Az árajánlat elküldését követően <strong>1–5 napon belül</strong> tudjuk a pontos
                árajánlatot kiküldeni.
              </li>
            </ul>
          </aside>
        </div>
      </section>

      <section className="svc-band svc-band--dark">
        <div className="svc-band-inner svc-closing">
          <h2>Raklapos árut szállíttatnál?</h2>
          <p>Küldd el a fő adatokat, és készítünk egy személyre szabott ajánlatot.</p>
          <Link className="primary-btn svc-closing-btn" to={QUOTE_RAKLAP_PATH}>
            Ajánlatot kérek
          </Link>
        </div>
      </section>

      <section className="svc-band svc-band--white svc-gyik-band">
        <div className="svc-band-inner svc-gyik-row">
          <p className="svc-gyik-text">
            Ha valami kérdésed maradt még, email vagy telefon előtt keresd a GYIK-ben.
            <br />
            Biztos rátalálsz a válaszra.
          </p>
          <Link className="svc-gyik-link" to="/gyik">
            Tovább a GYIK-hez →
          </Link>
        </div>
      </section>
    </main>
  );
}

